import { ToolSwitcher } from "./ToolSwitcher";
import { Link, useLocation } from "react-router-dom";
import {
  BookOpen,
  ChevronRight,
  LayoutGrid,
  MessageCircle,
} from "lucide-react";
import { TOOL_DIRECTORY } from "../app/toolDirectory";

const sections: Record<string, { label: string; route: string }> = {
  workmate: { label: "워크메이트", route: "/workmate" },
  classmate: { label: "클래스메이트", route: "/classmate" },
  informate: { label: "인포메이트", route: "/informate" },
  timetable: { label: "시간표", route: "/timetable/schools" },
  community: { label: "소통공간", route: "/community" },
  account: { label: "내 계정", route: "/account/profile" },
};
const directory = [...TOOL_DIRECTORY].sort(
  (a, b) => b.route.length - a.route.length,
);

export function ToolNavigation() {
  const { pathname } = useLocation();
  const tool = directory.find(
    (t) => pathname === t.route || pathname.startsWith(`${t.route}/`),
  );
  if (
    !tool ||
    pathname.startsWith("/community") ||
    pathname === "/timetable/schools"
  )
    return null;
  const section = sections[tool.section];
  if (!section) return null;
  return (
    <div className="fe-tool-navigation print:hidden">
      <nav
        aria-label="현재 도구 위치"
        className="min-w-0 flex flex-wrap items-center gap-2"
      >
        <Link to={section.route} className="inline-flex items-center gap-2">
          <LayoutGrid size={14} aria-hidden="true" />
          {section.label}
        </Link>
        <ChevronRight size={13} aria-hidden="true" />
        {pathname === tool.route ? (
          <span aria-current="page" className="font-semibold">
            {tool.name}
          </span>
        ) : (
          <Link to={tool.route}>{tool.name}{tool.route === "/workmate/worksheet-restore" ? "" : " 목록"}</Link>
        )}
      </nav>
      <div className="flex flex-wrap items-center gap-2 min-w-0">
        <ToolSwitcher />
        {tool.section !== "account" && (
          <details className="fe-tool-community-menu">
            <summary className="fe-tool-help">
              <MessageCircle size={15} /> 함께 나누기
            </summary>
            <div>
              <Link
                to={`/community/board/new?purpose=question&tool=${encodeURIComponent(tool.route)}`}
              >
                이 도구 질문하기
              </Link>
              <Link
                to={`/community/board/new?purpose=story&tool=${encodeURIComponent(tool.route)}`}
              >
                활용 경험 나누기
              </Link>
              <Link
                to={`/community/board?tag=${encodeURIComponent(tool.name)}`}
              >
                관련 이야기 보기
              </Link>
            </div>
          </details>
        )}
        <Link to={tool.guide} className="fe-tool-help">
          <BookOpen size={15} aria-hidden="true" /> 사용 방법
        </Link>
      </div>
    </div>
  );
}
